import { FOMO_BASE } from "@/config";

// Shared current value of the live FOMO waitlist counter so the waitlist
// success card ("You're #N") can stay in sync with the on-screen counter.
let current = FOMO_BASE;

export function setFomoValue(v) {
  if (typeof v === "number") current = v;
}

export function getFomoValue() {
  return current;
}
